import React, { useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRankingStar, faCalendarTime } from "@fortawesome/pro-regular-svg-icons";
import RoundedRectangle from "../../../RoundedRectangle";
import { ClavaContext } from "../../../../../config/contexts";
import { formatDate } from "../../../../../config/utils";
import { pathLeagueView } from "../../../../../config/routes";

type PreviewPanelProps = {
  leagueName: string;
  leagueId: number;
  startTime: number;
};

const PreviewPanel: React.FC<PreviewPanelProps> = ({ leagueName, leagueId, startTime }) => {
  const { l } = useContext(ClavaContext);
  const navigate = useNavigate();

  const { dateLabel, timeLabel } = useMemo(() => {
    const d = new Date(startTime);
    return {
      dateLabel: formatDate(d, l, false, false, true),
      timeLabel: formatDate(d, l, false, true)
    };
  }, [startTime, l]);

  return (
    <RoundedRectangle
      className="w-full overflow-hidden bg-bg-secondary dark:bg-bg-secondary-dark border border-light-gray dark:border-light-gray-dark"
      hasBorder
      hasTitle
      titleType="upLeft"
      titleKey="preview"
    >
      <div className="px-4 pt-4 pb-5 flex flex-col gap-3">
        <div className="flex items-center gap-2">
          <FontAwesomeIcon
            icon={faRankingStar}
            className="w-5 h-5 text-font-600 dark:text-font-600-dark"
          />
          <button
            type="button"
            onClick={() => navigate(pathLeagueView(leagueId, "table"))}
            className="bg-bg-100 dark:bg-bg-100-dark rounded-full px-2 py-0.5 hover:bg-primary-10 dark:hover:bg-primary-10-dark transition-colors"
          >
            <span className="text-sm text-font-600 dark:text-font-600-dark truncate">
              {leagueName}
            </span>
          </button>
        </div>
        <div className="flex items-center gap-2">
          <FontAwesomeIcon
            icon={faCalendarTime}
            className="w-5 h-5 text-font-600 dark:text-font-600-dark"
          />
          <span className="text-sm text-font-600 dark:text-font-600-dark">
            {dateLabel}, {timeLabel}
          </span>
        </div>
      </div>
    </RoundedRectangle>
  );
};

export default PreviewPanel;


